import { useState, useEffect } from "react";
import InputWithLabel from "./InputWithLabel";
import Button from "../buttons/button";
import SelectBox from "./SelectBox ";
import useTranslator from "../../../hooks/useTranslator";
import { getCurrentDate } from "../../../helpers/Utils";

const initialFormData = {
  // entered_date: "",
  type: "",
  status: "",
};

const OvenFilter = ({ onApplyFilter, onClose, filters = {} }) => {
  const [filtersData, setFiltersData] = useState({
    // entered_date: filters.entered_date || "",
    type: filters.type || "",
    status: filters.status || "",
  });

  const { _t } = useTranslator();

  useEffect(() => {
    setFiltersData({
      // entered_date: filters.entered_date || "",
      type: filters.type || "",
      status: filters.status || "",
    });
  }, [ filters.type, filters.status]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFiltersData({ ...filtersData, [name]: value });
  };

  const handleReset = (e) => {
    e.preventDefault();
    setFiltersData(initialFormData);
    onApplyFilter(initialFormData);
    if (onClose) onClose();
  };

  const handleApply = (e) => {
    e.preventDefault();
    onApplyFilter({ ...filtersData });
    if (onClose) onClose();
  };

    
    const types =  [
        { value: "cheeks", label: _t("type_cheeks", "Cheeks") },
        { value: "strips", label: _t("type_strips", "Strips") },
        {
            value: "cheeks/strips",
            label: _t("type_cheeks_strips", "Cheeks/Strips"),
        },
        {
            value: "tapita",
            label: _t("type_tapita", "Tapita"),
        },
        {
            value: "cheeks/tapita",
            label: _t("type_cheeks_tapita", "Cheeks/Tapita"),
        },
    ];

      const statusOptions = [
        { value: "all", label: _t("all", "All") },
        { value: "cooking", label: _t("status_cooking", "Cooking") },
        { value: "cooling_room", label: _t("status_cooling_room", "Cooling Room") },
        { value: "cart_unloaded", label: _t("status_cart_unloaded", "Cart Unloaded") },
      ];

    return (
        <div className="dropdown_body">
        <h5 className="mb-3 border-bottom">{_t("filter_heading", "Filter")}</h5>
            <SelectBox
                label="Type"
                name="type"
                value={filtersData.type}
                options={types?.map((list) => ({
                    value : list.value,
                    label: _t(list.label, list.label),
                }))}
                onChange={handleChange}
            />

              <SelectBox
                label={_t("status", "Status")}
                name="status"
                value={filtersData.status}
                options={statusOptions.map((status) => ({
                  value: status.value,
                  label: status.label,
                }))}
                onChange={handleChange}
              />

            {/* <InputWithLabel
                label={_t("entered_date", "Entered Date")}
                type="date"
                name="entered_date"
                value={filtersData.entered_date}
                onChange={handleChange}
                max={getCurrentDate("YYYY-MM-DD")}
            /> */}

            <div className="d-flex justify-content-between mt-3">
                <Button
                    onClick={handleReset}
                    label={_t("reset_button", "Reset")}
                    className="reset_btn"
                />
                <Button
                    className="cmn_btn"
                    label={_t("apply_button", "Apply")}
                    onClick={handleApply}
                />
            </div>
        </div>
    );
};

export default OvenFilter;
